// A single game table of a report with its own header and total

import GameListTable from './GameListTable';

export default function GameReportSection({
  title,
  total,
  totalPay,
  ...tableProps
}) {
  return (
    <div className='report-section'>
      <h6 className='header'>{title}</h6>
      <GameListTable {...tableProps} />
      <h6 className='total'>{total}</h6>
      {totalPay && <h6 className='total'>{totalPay}</h6>}
    </div>
  );
}
